import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import Fade from "react-reveal/Fade";
import TextField from "@mui/material/TextField";
import LeftMenu from "./LeftMenu";
import Alert from "@mui/material/Alert";
import { updatePassword } from "../../firebase";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "30px" },
});

const Dashboard = () => {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { currentUser } = useAuth();

  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [msg, setMsg] = useState("");

  console.log(currentUser);

  const handleSubmit = async () => {
    setLoading(true);
    if (pass === pass2 && pass.length > 6) {
      await updatePassword(currentUser, pass)
        .then(() => {
          console.log("Update successful.");
          // Update successful.
          setMsg("success");
          setTimeout(() => {
            setMsg("");
          }, 8000);
        })
        .catch((error) => {
          console.log("fail", error);

          switch (error.code) {
            case "auth/requires-recent-login":
              setMsg(
                "비밀번호를 바꾸시려면 다시 로그인 해주세요. 로그인 하시고 일정시간이 지나면 비밀번호를 바꾸실수 없습니다."
              );
              // navigate("/logout");
              break;
            default:
              setMsg("An undefined error happened. Please try again.");
          }
        });
    }
    if (pass.length < 6) {
      setMsg("Please put more than 6 characters for password.");
      setTimeout(() => {
        setMsg("");
      }, 8000);
    } else if (pass !== pass2) {
      setMsg("Password and confirm password are not same. Please check.");
      setTimeout(() => {
        setMsg("");
      }, 8000);
    }

    setLoading(false);
  };

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "19px", pb: 2, pl: 2 }}>
        <Box>{t("MY ACCOUNT")}</Box>
      </Grid>

      <LeftMenu cursor="password" />
      <Grid md={9} sm={12} className={classes.body}>
        <Box className={classes.title}>
          <Fade delay={300}>
            <Box sx={{ fontSize: "16px", fontWeight: "bold" }}>
              {t("Change your password")}
            </Box>
            <Box>
              {msg === "success" ? (
                <Alert severity="success" sx={{ mt: 3 }}>
                  {t("Password is successfully changed. Thank you.")}
                </Alert>
              ) : msg.length > 1 ? (
                <Alert severity="warning" sx={{ mt: 3 }}>
                  {msg}
                </Alert>
              ) : null}
              <TextField
                required
                fullWidth
                label={t("pass")}
                name="email"
                autoComplete="email"
                value={pass}
                type="password"
                onChange={(e) => setPass(e.target.value)}
                sx={{ width: 1 / 2, mt: 4, pr: 2 }}
              />
              <TextField
                required
                fullWidth
                label={t("pass_confirm")}
                name="email"
                autoComplete="email"
                type="password"
                value={pass2}
                onChange={(e) => setPass2(e.target.value)}
                sx={{ width: 1 / 2, mt: 2 }}
              />
              <Box>
                <button
                  onClick={handleSubmit}
                  className="custom_btn"
                  style={{
                    marginTop: "40px",
                    width: "240px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  {loading ? (
                    <span>{t("Processing")}...</span>
                  ) : (
                    <span>{t("Update")}</span>
                  )}
                </button>
              </Box>
            </Box>
          </Fade>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
